export default "__VITE_ASSET__CXszg5bb__"